<script setup lang="ts">
withDefaults(defineProps<{ title: string; position?: 'bottom' | 'top' }>(), {
  position: 'bottom',
});
</script>

<template>
  <div
    class="font-pds bg-pan text-pan-encre fixed left-1/2 z-60 flex w-[760px] max-w-[calc(100%-24px)] -translate-x-1/2 items-center gap-3 rounded-[24px] px-5 py-4 sm:gap-5 sm:px-7 sm:py-5"
    :class="
      position === 'top' ? 'top-[136px] lg:top-[84px]' : 'bottom-4 sm:bottom-6'
    "
    role="status"
  >
    <slot name="icon" />
    <div class="flex min-w-0 flex-1 flex-col gap-1">
      <p class="text-[14px] leading-[1.4] font-semibold">{{ title }}</p>
      <p class="text-[12px] leading-[1.45]"><slot /></p>
    </div>
    <slot name="aside" />
  </div>
</template>
